import { useMutation } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import Auth, { type ChangePasswordResponse } from 'src/services/api/auth/Auth';

type ApiResponse = ChangePasswordResponse
type Response = ApiResponse;

type Request = {
    token: string;
    newPassword: string;
}

export const useChangePassword = () => {
    return useMutation<Response, IStandardErrorResponse, Request>(
        (payload) => Auth.changePassword(payload.token, payload.newPassword)
    );
};